import React from 'react'
import { Box, Heading, Text } from 'rebass'

type LayoutProps = {
  data: Array<string>
}

const ContentList = ({ data }: LayoutProps) => {
  return (
    <Box variant="contentList">
      <Box sx={{ mb: 11 }}>
        <Heading>Key Points To Remember</Heading>
      </Box>
      <Box as="ul">
        {data.map(item => (
          <Box as="li" sx={{ pb: 4 }}>
            <Text variant="content" flex={1}>
              {item}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default ContentList
